import React from "react";
import { notification } from "../../utils/Notifications.tsx";
import { deleteIncentive } from "../../services/perceptions.service.ts";
import { toCamelCase } from "../../hooks/toCameCase.tsx";

interface DeleteIncentiveModalProps {
  closeFn: () => void;
  incentive: any;
  onSuccess: () => void;
}

const DeleteIncentiveModal = ({ closeFn, incentive, onSuccess }: DeleteIncentiveModalProps) => {
  const removeIncentive = async () => {
    try {
      await deleteIncentive(incentive.id);
      onSuccess();
      closeFn();
      notification("Eliminado", "Bono eliminado correctamente", "success");
    } catch (error: any) {
      console.error("Error al eliminar:", error);
      notification("Error", error?.message || "No se pudo eliminar el bono", "danger");
    }
  };

  const partnerName = incentive?.partner?.person
    ? toCamelCase(
        `${incentive.partner.person.firstName || ""} ${
          incentive.partner.person.lastName || ""
        } ${incentive.partner.person.secondLastName || ""}`
      )
    : "Colaborador";

  return (
    <>
      <p className="fs-15px">
        ¿Estás seguro de que deseas eliminar el bono "{incentive?.name}" de {partnerName}?
      </p>
      <p className="fs-14px text-muted">
        Esta acción no se puede deshacer.
      </p>
      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button className="btn btn-danger" onClick={() => removeIncentive()}>
          Eliminar
        </button>
      </div>
    </>
  );
};

export default DeleteIncentiveModal;
